import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersist from 'vuex-persist'
import {
  DELETE_VIDEO,
  SET_TOKEN,
  SET_USER,
  SET_QUIZ_SESSION_TOKEN,
  DELETE_USER,
  SET_VIDEO,
  SET_USER_PERMISSION,
  SET_VIDEO_SECONDS_STOPPED,
  DELETE_VIDEO_SECONDS_STOPPED,
  SET_PUBLIC_COURSE_SEARCH,
  SET_PUBLIC_COURSE_ENTER,
  DELETE_PUBLIC_COURSE_ENTER
} from './mutation-types'

Vue.use(Vuex)

const vuexLocalStorage = new VuexPersist({
  key: 'vuex', // The key to store the state on in the storage provider.
  storage: window.localStorage // or window.sessionStorage or localForage
  // Function that passes the state and returns the state with only the objects you want to store.
  // reducer: state => state,
  // Function that passes a mutation and lets you decide if it should update the state in localStorage.
  // filter: mutation => (true)
})

export default new Vuex.Store({
  state: {
    pub: {
      filters: {
        term: null,
        categories: [],
        prices: [],
        durations: [],
      },
      courseToEnter: null
    },
    auth: {
      user: {
        permissions: {
          createVideo: false,
          showVideo: false
        },
        id: null,
        name: null,
        thumb: null,
      },
      token: null,
      quizSessionToken: null,
    }
  },
  getters: {
    authenticated: ({ auth }) => auth.user && auth.token,
    getContent: ({ video }) => video,
    getContentSecondsStopped: ({ videoSecondsStopped }) => videoSecondsStopped,
    permissions: ({ auth }) => auth.user.permissions,
    getToken: ({ auth }) => auth.token,
    getQuizSessionToken: ({ auth }) => auth.quizSessionToken,
    getUser: ({ auth }) => auth.user,
    getPublicFilters: ({ pub }) => pub.filters,
    getCurseEnter: ({ pub }) => pub.courseToEnter
  },
  mutations: {
    [SET_TOKEN] (state, token) {
      state.auth.token = token
    },
    [SET_QUIZ_SESSION_TOKEN] (state, token) {
      state.auth.quizSessionToken = token
    },
    [SET_USER] (state, data) {
      if (data.id) {
        state.auth.user.id = data.id
      }
      if (data.name) {
        state.auth.user.name = data.name
      }
      if (data.thumb) {
        state.auth.user.thumb = data.thumb
      }
    },
    [DELETE_USER] (state) {
      state.auth.user.id = null
      state.auth.user.name = null
      state.auth.user.thumb = null
    },
    [SET_USER_PERMISSION] (state, permissions) {
      state.auth.user.permissions = permissions
    },
    [SET_VIDEO] (state, video) {
      state.video = video
    },
    [SET_VIDEO_SECONDS_STOPPED] (state, seconds) {
      state.videoSecondsStopped = seconds
    },
    [DELETE_VIDEO] (state) {
      delete state.video
    },
    [DELETE_VIDEO_SECONDS_STOPPED] (state) {
      delete state.videoSecondsStopped
    },
    [DELETE_VIDEO_SECONDS_STOPPED] (state) {
      delete state.videoSecondsStopped
    },
    [SET_PUBLIC_COURSE_ENTER] (state, courseId) {
      state.pub.courseToEnter = courseId
    },
    [DELETE_PUBLIC_COURSE_ENTER] (state) {
      state.pub.courseToEnter = null
    },
    [SET_PUBLIC_COURSE_SEARCH] (state, filters) {
      if (filters.hasOwnProperty('term')) {
        state.pub.filters.term = filters.term
      }
      if (filters.hasOwnProperty('categories')) {
        state.pub.filters.categories = filters.categories
      }
      if (filters.hasOwnProperty('prices')) {
        state.pub.filters.prices = filters.prices
      }
      if (filters.hasOwnProperty('durations')) {
        state.pub.filters.durations = filters.durations
      }
    }
  },
  actions: {
    setToken ({ commit }, token) {
      commit(SET_TOKEN, token)
    },
    setQuizSessionToken ({ commit }, token) {
      commit(SET_QUIZ_SESSION_TOKEN, token)
    },
    setContent ({ commit }, video) {
      commit(SET_VIDEO, video)
    },
    deleteContent ({ commit }) {
      commit(DELETE_VIDEO)
    },
    deleteContentSecondsStopped ({ commit }) {
      commit(DELETE_VIDEO_SECONDS_STOPPED)
    },
    setContentSecondsStopped ({ commit }, seconds) {
      commit(SET_VIDEO_SECONDS_STOPPED, seconds)
    },
    setUser ({ commit }, data) {
      commit(SET_USER, data)
    },
    clearUser ({ commit }) {
      commit(SET_USER, { name: null, id: null, thumb: null })
    },
    setUserPermissions ({ commit }, permissions) {
      commit(SET_USER_PERMISSION, permissions)
    },
    setPublicCourseEnter ({ commit }, courseId) {
      commit(SET_PUBLIC_COURSE_ENTER, courseId)
    },
    clearPublicCourseEnter ({ commit }) {
      commit(DELETE_PUBLIC_COURSE_ENTER)
    },
    setPublicFilters ({ commit }, filters) {
      commit(SET_PUBLIC_COURSE_SEARCH, filters)
    },
    clearPublicFilters ({ commit }) {
      commit(SET_PUBLIC_COURSE_SEARCH, {
        term: null,
        categories: [],
        prices: [],
        durations: [],
      })
    },
    clearState ({ commit }) {
      commit(SET_TOKEN, null)
      commit(SET_QUIZ_SESSION_TOKEN, null)
      commit(DELETE_USER)
      commit(DELETE_VIDEO)
      commit(DELETE_VIDEO_SECONDS_STOPPED)
      commit(SET_USER_PERMISSION, {
        createVideo: false,
        showVideo: false
      })
    }
  },
  plugins: [vuexLocalStorage.plugin]
})
